import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';

export default function FooterSmall() {
    const { t } = useTranslation();

    return (
        <>
            <Row className="footer-privacy footer-small">
                <Col sm={12}>
                    <a href="https://www.kawasaki.com/en-us/about/legal-policies" target="_blank" rel="noreferrer">{t('Footer.Your Privacy Rights')}</a>
                    <a href="https://www.kawasaki.com/en-us/about/legal-policies#caPrivacyRights" target="_blank" rel="noreferrer">{t('Footer.CA Privacy Rights')}</a>
                    <a href="https://www.kawasaki.com/en-us/about/legal-policies#termsConditionsUse" target="_blank" rel="noreferrer">{t('Footer.Terms of Use')}</a>
                </Col>
            </Row>
        </>
    )
}